import { ActionType, createAction } from "typesafe-actions";

import User from "@mapmycustomers/shared/types/User";

export const initializeUserColors = createAction("@userColor/initializeUserColors")<void>();

export const setSelectedUserIds = createAction("@userColor/setSelectedUserIds")<User["id"][]>();

export type Actions = ActionType<typeof initializeUserColors | typeof setSelectedUserIds>;
